import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Spinner } from "@/components/ui";

/**
 * Guard for every marketplace screen.
 *
 * Mirrors OnboardedRoute's three-state handling, including the deliberate
 * middle case: a signed-in Firebase user whose API record has not loaded keeps
 * spinning rather than being bounced to onboarding, so an unreachable API does
 * not look like an unfinished signup.
 */
export default function MarketplaceRoute({ children }: { children: React.ReactNode }) {
  const { firebaseUser, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!firebaseUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user.marketplaceRole) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
